import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ConversionModalContainer from '../../components/SetupSubPageComps/ConversionComps/ConversionModalContainer';
import ShowAllConversions from '../../components/SetupSubPageComps/ConversionComps/ShowAllConversions';
import ConversionProvider from '../../contexts/ConversionProvider';

const Conversion = () => {
  // rendering conversion page component here
  return (
    <>
      <PageTitle title='Minute Conversions' />

      <ConversionProvider>
        <ShowAllConversions />
        <ConversionModalContainer />
      </ConversionProvider>
    </>
  );
};

export default Conversion;
